import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { WorkerService } from 'src/app/data/worker.service';

interface IRequest {
  WorkerId: number;
  Page: number;
  Count: number;
  SortingDirection: string;
  SortingField: string;
}

@Injectable()
export class WorkedDaysDataSource {
  private workerService = inject(WorkerService);

  public count$ = new BehaviorSubject<number>(0);
  public workedDaysSubject = new Subject<IRequest>();
  public workedDays$ = this.workedDaysSubject.pipe(
    switchMap((req) =>
      this.workerService
        .getWorkerEmploymentsWithWorkedDays(req.WorkerId, {
          Page: req.Page,
          Count: req.Count,
          SortingDirection: req.SortingDirection,
          SortingField: req.SortingField,
        })
        .pipe(
          tap((pagedRes) => this.count$.next(pagedRes.Count)),
          map((pagedRes) => pagedRes.Results),
        ),
    ),
  );
}
